import React from 'react';
import {
  MenuList,
  MenuItem,
} from '@grnhse/seedling/lib/birch/components/expandable_menu';
import { withLocalePrefix } from 'shared/utils/translation';
import { useRediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';
import LazyEllipsisMenu from 'talent_matching/components/shared/lazy_ellipsis_menu';

const t = withLocalePrefix('talent_matching.rediscovery.table.actions');

type RediscoveryRowActionsProps = {
  applicationId: number;
};

const RediscoveryRowActions = ({
  applicationId,
}: RediscoveryRowActionsProps) => {
  const { application } = useRediscoveryApplication(applicationId);

  if (!application) {
    return null;
  }

  const handleViewCandidate = () => {
    // Placeholder - will be implemented in future
  };

  const handleAddToJob = () => {
    // Placeholder - will be implemented in future
  };

  return (
    <LazyEllipsisMenu ariaLabel={t('actions')}>
      <MenuList>
        <MenuItem onSelect={handleViewCandidate} disabled>
          {t('view_candidate')}
        </MenuItem>
        <MenuItem onSelect={handleAddToJob} disabled>
          {t('add_to_job')}
        </MenuItem>
      </MenuList>
    </LazyEllipsisMenu>
  );
};

export default RediscoveryRowActions;
